import {
  EXPENSES_ALL,
  EXPENSES_GET,
  EXPENSES_DEL,
  EXPENSES_PUT,
  EXPENSES_POST,
  EXPENSES_LOADING,
  EXPENSES_ERROR,
  EXPENSES_RESET,
  EXPENSES_PENDING_COUNT,
} from '../types';

import api from '../../../utils/functions/api';

export const expensesCreate = (payload) => async (dispatch) => {
  try {
    dispatch({ type: EXPENSES_LOADING });
    const { data } = await api.post(
      `${process.env.REACT_APP_API_URL}/expenses`,
      payload,
    );
    dispatch({ type: EXPENSES_POST, payload: data });
  } catch (error) {
    console.error(error);
    dispatch({ type: EXPENSES_ERROR });
    throw new Error(error);
  }
};

export const expensesCreateWithOutNotify = (payload) => async (dispatch) => {
  try {
    dispatch({ type: EXPENSES_LOADING });
    const { data } = await api.post(
      `${process.env.REACT_APP_API_URL}/expenses/won`,
      payload,
    );
    dispatch({ type: EXPENSES_POST, payload: data });
  } catch (error) {
    console.error(error);
    dispatch({ type: EXPENSES_ERROR });
    throw new Error(error);
  }
};

export const expensesAll = (params) => async (dispatch) => {
  try {
    dispatch({ type: EXPENSES_LOADING });
    const {
      name = '',
      size = 99999,
      page = 1,
      me = '',
      search = '',
      findProject = '',
      dateStart: dateStartParam = '',
      dateEnd: dateEndParam = '',
      status: statusFilter = '',
      statuses: statusesFilter = '',
      sortBy = '',
      sortDir = '',
    } = params;
    const dateStart = dateStartParam instanceof Date ? dateStartParam.toISOString() : dateStartParam;
    const dateEnd = dateEndParam instanceof Date ? dateEndParam.toISOString() : dateEndParam;
    const q = new URLSearchParams({ name, size, page, me, search, findProject });
    if (dateStart) q.set('dateStart', dateStart);
    if (dateEnd) q.set('dateEnd', dateEnd);
    if (statusFilter) q.set('status', statusFilter);
    if (statusesFilter) q.set('statuses', statusesFilter);
    if (sortBy) q.set('sortBy', sortBy);
    if (sortDir) q.set('sortDir', sortDir);
    const { data, status } = await api.get(
      `${process.env.REACT_APP_API_URL}/expenses?${q.toString()}`,
    );
    if (status === 200) {
      dispatch({ type: EXPENSES_ALL, payload: data });
    }
  } catch (error) {
    console.error(error);
    dispatch({ type: EXPENSES_ERROR });
  }
};

export const expensesGetDaily = (params) => async (dispatch) => {
  try {
    const { date = '', dateStart = '', dateEnd = '' } = params;
    const { data, status } = await api.get(
      `${process.env.REACT_APP_API_URL}/expenses/daily/report?date=${date}&dateStart=${dateStart}&dateEnd=${dateEnd}`,
    );
    if (status === 200) {
      dispatch({ type: EXPENSES_ALL, payload: data });
    }
  } catch (error) {
    console.error(error);
    dispatch({ type: EXPENSES_ERROR });
    throw new Error(error);
  }
};

export const expensesGet = (id) => async (dispatch) => {
  try {
    const { data, status } = await api.get(
      `${process.env.REACT_APP_API_URL}/expenses/${id}`,
    );
    if (status === 200) {
      dispatch({ type: EXPENSES_GET, payload: data });
    }
  } catch (error) {
    console.error(error);
    dispatch({ type: EXPENSES_ERROR });
    throw new Error(error);
  }
};

export const expensesPut = (id, payload) => async (dispatch) => {
  try {
    dispatch({ type: EXPENSES_LOADING });
    const { data } = await api.put(
      `${process.env.REACT_APP_API_URL}/expenses/${id}`,
      payload,
    );
    dispatch({ type: EXPENSES_PUT, payload: data });
  } catch (error) {
    console.error(error);
    dispatch({ type: EXPENSES_ERROR });
    throw new Error(error);
  }
};
// sync ยอดค่าแรงต่อโครงการ (จาก TimestampProjectCost.js) เข้า Expenses แบบ draft (isLabor) ระหว่างยังไม่กด
// บันทึกเงินเดือน — ไม่ผูกกับ EXPENSES_* redux slice เลย (HrReportV2 ไม่ได้อ่าน state.expenses)
export const laborDraftSync = (payload) => async () => {
  try {
    const { data } = await api.post(
      `${process.env.REACT_APP_API_URL}/expenses/labor-draft-sync`,
      payload,
    );
    return data;
  } catch (error) {
    console.error(error);
    return null;
  }
};

// ปุ่ม "รีเซ็ต" ในแท็บ "ตั้งเบิกค่าแรง" — ลบรายการค่าแรง auto-sync ทิ้ง 1 รายการ (เฉพาะที่ยัง PENDING และงวด
// ยังไม่บันทึกเงินเดือน — backend เช็คซ้ำอีกชั้น) คืน {project_id, labor_period_start, labor_period_end,
// labor_emp_type} ให้ผู้เรียกเอาไป mount HrReportV2 แบบซ่อน (lockPeriod) คำนวณยอดสดแล้ว sync สร้างใหม่ต่อเอง
export const resetLaborExpense = (id) => async () => {
  const { data } = await api.delete(
    `${process.env.REACT_APP_API_URL}/expenses/${id}/labor-reset`,
  );
  return data;
};

export const expensesDelete = (id) => async (dispatch) => {
  try {
    dispatch({ type: EXPENSES_LOADING });
    const { data } = await api.delete(
      `${process.env.REACT_APP_API_URL}/expenses/${id}`,
    );
    dispatch({ type: EXPENSES_DEL, payload: data });
  } catch (error) {
    console.error(error);
    dispatch({ type: EXPENSES_ERROR });
    throw new Error(error);
  }
};

export const expensesRemoveImage = (expensesId, imageId) => async (dispatch) => {
  try {
    dispatch({ type: EXPENSES_LOADING });
    await api.delete(
      `${process.env.REACT_APP_API_URL}/expenses/${expensesId}/images/${imageId}`,
    );
    dispatch({ type: EXPENSES_PUT, payload: {} });
  } catch (error) {
    console.error(error);
    dispatch({ type: EXPENSES_ERROR });
    throw new Error(error);
  }
};

export const expensesPendingCount = () => async (dispatch) => {
  try {
    const today = new Date().toISOString().split('T')[0];
    const pendingStatuses = ['PENDING', 'PREAPPROVE', 'APPROVE_1', 'APPROVE_2'];
    const results = await Promise.all(
      pendingStatuses.map((s) =>
        api.get(`${process.env.REACT_APP_API_URL}/expenses?status=${s}&dateStart=${today}&dateEnd=${today}&size=1&page=1`),
      ),
    );
    const count = results.reduce((sum, { data, status }) => {
      if (status === 200) return sum + (data?.total ?? data?.rows?.length ?? 0);
      return sum;
    }, 0);
    dispatch({ type: EXPENSES_PENDING_COUNT, payload: count });
  } catch (error) {
    console.error(error);
  }
};

export const expensesReset = () => async (dispatch) => {
  try {
    dispatch({ type: EXPENSES_RESET });
  } catch (error) {
    console.error(error);
    dispatch({ type: EXPENSES_ERROR });
    throw new Error(error);
  }
};
